import { createContext } from 'react';
import { observer } from 'mobx-react-lite';
import RecurringPaymentComponentStore from './recurring-payment-component.store';

export const RecurringPaymentComponentContext = createContext(new RecurringPaymentComponentStore());

type RecurringPaymentComponentContextProviderProps = {
  children: any;
  store: RecurringPaymentComponentStore;
}
export const RecurringPaymentComponentContextProvider = observer<RecurringPaymentComponentContextProviderProps>(({store, children}) => (
  <RecurringPaymentComponentContext.Provider value={store}>
    {children}
  </RecurringPaymentComponentContext.Provider>
));